import { getSelectedPeriod } from "../../../../services/GroupContext";
import { findAdjustedCapsForCompany } from "../utils/fullReturnOutputUtils";
import { getRelevantGroupCompanies } from "../utils/helpers";
import { getAllocatedReactivationsMetrics } from "../utils/metrics";

export const getAllocatedReactivationsCoreRows = () => {
  const excelData = getAllocatedReactivationsMetrics();
  const companies = getRelevantGroupCompanies();
  const adjustedCaps = getSelectedPeriod()?.adjusted_caps;

  const allocatedReactivationsList = [
    [
      "",
      "Index no.",
      "Name of company",
      "Disallowances less earlier reactivations brought forward start of AP1",
      "Reactivation  - for period of account.  (Apply to earlier company APs before later ones)",
    ],
    ["", "", "", "", 'Enter an amount or "0" in each box'],
  ];

  const numOfCompanies = companies.length;
  for (let i = 0; i < 300; i++) {
    let rowNumber = i + 1;
    let row = ["", rowNumber, "", "", "", "", "", "", "", ""];

    if (i < numOfCompanies) {
      let companyName = companies[i].company_name;
      let adjustedCapsForCompany = findAdjustedCapsForCompany(
        adjustedCaps,
        companies[i].company_ID,
      );
      //JCW TO-DO - To discuss with Katya whether we need a sort function in here to make sure this only ever takes the earliest
      let bfdTotal = adjustedCapsForCompany[0]
        ? adjustedCapsForCompany[0].bfd_subtotal_gbp
        : "";
      let cprTotal = adjustedCapsForCompany[0]
        ? adjustedCapsForCompany[0].allocated_reactivation
        : "";
      row = ["", rowNumber, companyName, bfdTotal, cprTotal];
    }

    allocatedReactivationsList.push(row);
  }

  const allocatedReactivationsFooter = [
    [],
    excelData.aReact_Row315,
    excelData.aReact_Row316,
    [],
    ["", "Key"],
    ["", "Descriptive field", , "Numerical entry, £", "Note"],
  ];

  const rows = allocatedReactivationsList.concat(allocatedReactivationsFooter);

  return rows;
};

export const getReactivationsTableRows = () => {
  const adjustedCaps = getSelectedPeriod()?.adjusted_caps;

  const reactivationsList = [
    [
      "",
      "Name of company",
      "Disallowances brought forward",
      "Reactivations allocated to company (GBP)",
      "Election to override default order (s377(3)) applied?",
    ],
  ];

  const allocationReactivationsData = adjustedCaps?.filter(
    (cap) => cap?.cpr_total_gbp,
  );
  const numOfReactivations = allocationReactivationsData?.length || 0;

  for (let i = 0; i < 300; i++) {
    let row = ["", "", "", "", ""];

    if (i < numOfReactivations) {
      let cap = allocationReactivationsData[i];

      let companyName = cap?.company_name || "";
      let bfd = (
        cap?.bfd_subtotal_gbp + cap?.bfdadj_subtotal_gbp
      )?.toLocaleString();
      let cpr = cap?.cpr_subtotal_gbp?.toLocaleString();
      let apply_s377_3_election = cap?.election_override_automatic_allocations
        ? "Yes"
        : "No";

      row = ["", companyName, bfd, cpr, apply_s377_3_election];
    }

    reactivationsList.push(row);
  }

  return reactivationsList;
};

export const getAllocatedReactivationsExcelData = (excelData) => {
  const allocatedReactivationsHeader = [
    [],
    ["", "Interest Restriction Return Page 6"],
    [],
    [
      "",
      "Statement of allocated interest reactivations (Full return and where interest reactivation arises, only)",
    ],
    [],
    ["", "Fields below copy from p1"],
    excelData.ukGC_Row7,
    excelData.ukGC_Row8,
    excelData.ukGC_Row9,
    excelData.ukGC_Row10,
    [],
  ];

  const allocatedReactivationsCoreRows = getAllocatedReactivationsCoreRows();
  const rows = allocatedReactivationsHeader.concat(
    allocatedReactivationsCoreRows,
  );

  return rows;
};
